import React from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";

export function ServiceCenterModal({
  isOpen,
  newServiceCenter,
  onSubmitServiceCenter,
  onCancel,
}) {
  return (
    <Modal isOpen={isOpen} contentLabel="Add Note" className="confirm-modal">
      <div className="card">
        <button onClick={onCancel} className="confirm-modal-close">
          <MdClose />
        </button>
        <div className="card-header">Service Center</div>
        <form>
          <div className="card-body">
            {newServiceCenter ? (
              <div className="mb-3">
                <div>
                  Once this service centre has been selected, only a Super Admin
                  can change it, are you sure?
                </div>
              </div>
            ) : (
              <div className="mb-3">Please select service center first!</div>
            )}
            {newServiceCenter && (
              <button
                type="submit"
                className="btn btn-outline-primary mr-3"
                data-testid="modal-approve-btn"
                onClick={onSubmitServiceCenter}
              >
                Change
              </button>
            )}
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onCancel}
              data-testid="modal-approve-btn-cancel"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}
